import axios from 'axios'
import { api } from '../config'

const { mtbAPI } = api

export { axios }

const client = axios.create({
  baseURL: mtbAPI,
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
    'media-type': 'application/json'
  },
})
client.interceptors.response.use(
  response => {
    return response.data.data
  },
  (error) => {
    const { response: { config, data: { message }, status } } = error
    if (status === 401 || status === 403 ) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('clientPortalCompany')
      localStorage.removeItem('clientPortalUser')
      if (config.url !== 'client-portal-users/verify') return window.location.href = '/login'
    }

    if (status === 404) {
      const newError = new Error()
      newError.message = 'APi Not found'
      throw newError
    }

    if (typeof message === 'string') {
      const newError = new Error()
      newError.message = message
      throw newError
    }
    else throw error
})
client.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) config.headers.common['Authorization'] = `Bearer ${token}`
  return config
})

export const amzClient = axios.create({
  headers: { 'Content-Type': 'text/csv' },
})

export const amzUploadFileEvidence = (fileEvidenceType = '') => {
  return axios.create({ headers: { 'x-amz-acl': 'private', 'Content-Type': fileEvidenceType } })
}


export default client